import React, { useState } from 'react';

const bpoServicesData = [
  {
    id: 'inbound',
    title: 'Inbound Call Center',
    contentTitle: 'Inbound Call Center',
    intro: 'Our Inbound call center handles incoming calls for the clients. These calls are from customers who require help with the product or services. Experts Communication presents quick and efficient customer support to resolve the occurring queries. We help our clients with:',
    points: [
      'Customer Inquiry Resolution',
      'Product Support Services',
      'Customer Concern Resolution',
      'Backend Assistance',
      'IT Support (Technical Service)',
      'Emergency Help & Assistance'
    ],
    closing: 'In inbound call center services, we offer 24/7 support to build stronger customer relationships. We answer their queries and problems with effective solutions. Our company improves customer satisfaction for your business, and it can create brand loyalty.'
  },
  {
    id: 'outbound',
    title: 'Outbound Call Center',
    contentTitle: 'Outbound Call Center',
    intro: 'We offer a complete outbound call center service. In outbound call center services, we initiate contact with the customer at the correct time. It brings us more conversions. We want to improve the customer experience with our technical solutions. Our outbound call center service helps clients with the following:',
    points: [
      'Client Acquisition',
      'Data Collection',
      'Marketing Campaigns',
      'Client Engagement and Customer Retention',
      'Appointment Scheduling',
      'Accounts Receivable Management',
      'Fund Solicitation',
    ],
    closing: 'At Experts Communication, our agents call potential and current customers. We reach out to people for promotion, follow up, or to generate leads. Our agents are very skilled and professional, and they know how to represent your brand positively with communication.'
  },
  {
    id: 'telemarketing',
    title: 'Telemarketing',
    contentTitle: 'Telemarketing',
    intro: 'Experts Communication’s Telemarketing services drive direct results and improve your sales efforts. We utilize strategic outbound calling campaigns to connect with potential and existing customers and close the deals. Experts Communication delivers telemarketing services to aid your business expansion and advancement. Our BPO services company produces valuable prospects via telemarketing services. We also assist you in creating strong customer relationships. We assist our clients with:',
    points: [
      'Sales Lead Generation',
      'Direct Sales and Product Promotion',
      'Cold Calling',
      'Market Research and Surveys',
      'Follow-up Calls',
      'Customer Service & Support',
      'Database Cleanup & Management',
      'B2B and B2C Sales',
      'Subscription Renewals',
    ],
    closing: 'At Experts Communication, we deliver a positive customer experience during every interaction. Our telemarketing agents have all the tools and knowledge to communicate your brand message, drive sales, and build customer relationships. We handle all calls with professionalism and respect, and our focus is to achieve your business objectives.'
  },
  {
    id: 'customer-support',
    title: 'Customer Support',
    contentTitle: 'Customer Support',
    intro: 'Experts Communication provides complete customer support solutions to improve customer satisfaction and grow your business. It is important to have exceptional support if you want to retain customers and drive positive word of mouth. Our outsourcing company resolves customer issues with professionalism. We assist our clients with:',
    points: [
      'Multi Channel Support',
      'Technical Troubleshooting',
      'Order and Billing Assistance',
      'Feedback Collection and Analysis',
      'Product Information and Guidance',
      'Complaint Handling and Resolution',
    ],
    closing: 'At Experts Communication, we prioritize customer satisfaction and offer timely and effective support. Our agents pay full attention to the customer and communicate with them to resolve their issues.'
  },
  {
    id: 'mca-leads',
    title: 'MCA Lead Generation',
    contentTitle: 'MCA Lead Generation',
    intro: 'Our call center services offer targeted MCA (Merchant Cash Advance) lead generation services. We connect you with qualified business owners who need immediate funding solutions. We understand the unique demands of the MCA industry, and we utilize our expertise to deliver high-quality leads that convert. We assist our clients with:',
    points: [
      'Qualified Lead Identification',
      'Direct Outreach and Engagement',
      'Application Pre-Qualification',
      'Appointment Setting and Scheduling',
      'Data Verification and Validation',
      'Lead Nurturing and Follow-Up'
    ],
    closing: 'At Experts Communication, we deliver the best MCA lead generation services to drive results. We use industry leading techniques and technologies to connect you with qualified business owners who need funding capital.'
  },
  {
    id: 'tcpa-leads',
    title: 'TCPA Compliant Leads',
    contentTitle: 'TCPA Compliant Leads',
    intro: 'Experts Communication generates leads that adhere to the Telephone Consumer Protection Act (TCPA). We provide TCPA Compliant Leads to conduct your marketing campaigns ethically and legally. We assist our clients with:',
    points: [
      'Express Written Consent Acquisition',
      'Data Verification and Compliance Audits',
      'Time-Stamped and Auditable Records',
      'Opt-Out Management',
      'Lead Source Transparency',
      'Training and Education'
    ],
    closing: 'We prioritize ethical lead generation and regulatory compliance. Our TCPA Compliant Leads service provides you with the peace of mind of knowing that your marketing efforts are conducted responsibly and legally.'
  },
  {
    id: 'auto-insurance',
    title: 'Auto Insurance Lead Generation',
    contentTitle: 'Auto Insurance Lead Generation',
    intro: 'Our call center services offer Auto Insurance Lead Generation Services to connect you with qualified prospects actively seeking car insurance coverage. Our experienced team engages potential customers and gathers essential information for a better sales process.',
    points: [
      'Targeted Lead Qualification',
      'Real-Time Lead Delivery',
      'Data Accuracy and Verification',
      'Customized Lead Generation Campaigns',
      'Appointment Setting and Scheduling',
      'Compliance and Regulatory Adherence'
    ],
    closing: 'You can accelerate your auto insurance sales with our lead generation service. At our outsourcing company, we deliver a consistent flow of leads so that you can focus on closing deals.'
  },
  {
    id: 'health-insurance',
    title: 'Health Insurance Lead Generation',
    contentTitle: 'Health Insurance Lead Generation',
    intro: 'We provide BPO services in Pakistan to connect you with individuals who are strongly interested in health insurance plans. We understand the complexities of the health insurance market and use the best strategies to generate leads.',
    points: [
      'Targeted Demographic Qualification',
      'Needs-Based Lead Generation',
      'Real-Time Lead Delivery and Management',
      'Comprehensive Lead Data',
      'Appointment Setting and Consultation Scheduling',
      'Compliance and Privacy Assurance'
    ],
    closing: 'Our team provides the best health insurance leads that drive growth and success. We use proven techniques to connect you with qualified prospects. We focus on ethical telemarketing, follow all regulations, and deliver quality leads that match your business goals.'
  }
];

function BpoServicesTabs() {
  const [activeTabId, setActiveTabId] = useState('inbound');

  const activeService = bpoServicesData.find((item) => item.id === activeTabId) || bpoServicesData[0];

  return (
    <section className="bpo-tabs-section">
      <div className="container">
        {/* Section Header: Title on Left, Paragraphs on Right */}
        <div className="bpo-tabs-header-row">
          <div className="bpo-tabs-header-left">
            <h2 className="bpo-tabs-main-title">
              Our Leading BPO Services:
            </h2>
          </div>
          <div className="bpo-tabs-header-right">
            <p className="bpo-tabs-header-p">
              In today’s fast digital world, navigating the landscape of IT services and technology can feel overwhelming, especially for businesses that focus on growth rather than gadgets.
            </p>
            <p className="bpo-tabs-header-p">
              In today’s fast digital world, navigating the landscape of IT services and technology can feel overwhelming, especially for businesses that focus on growth rather than gadgets.
            </p>
          </div>
        </div>

        {/* Tabs & Content Layout */}
        <div className="bpo-tabs-main-grid">
          {/* Left Side: Vertical Tabs List with Black Background */}
          <div className="bpo-tabs-sidebar">
            <ul className="bpo-tabs-list">
              {bpoServicesData.map((item) => {
                const isActive = item.id === activeTabId;
                return (
                  <li key={item.id} className="bpo-tab-item">
                    <button
                      className={`bpo-tab-button ${isActive ? 'active' : ''}`}
                      onClick={() => setActiveTabId(item.id)}
                    >
                      {item.title}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Right Side: Tab Details Content */}
          <div className="bpo-tab-content-card">
            <h3 className="bpo-tab-content-heading">
              {activeService.contentTitle}
            </h3>

            <p className="bpo-tab-content-intro">
              {activeService.intro}
            </p>

            <ul className="bpo-tab-bullet-list">
              {activeService.points.map((point, index) => (
                <li key={index} className="bpo-tab-bullet-item">
                  <span className="bpo-bullet-dot">•</span>
                  <span className="bpo-bullet-text">{point}</span>
                </li>
              ))}
            </ul>

            <p className="bpo-tab-content-closing">
              {activeService.closing}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BpoServicesTabs;
